/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/1/19
 * Time: 10:26 AM
 */
import * as actionTypes from '../Action/actionTypes';

const initialState = {
  // total counts
  visitor_count_list: {
    checkOut: 0,
    notCheckOut: 0,
    total: 0,
    overdue: 0,
  },

  visitor_count_list_graph:[],
  visitor_times_list_graph: ["7-8", "8-9", "9-10", "10-11", "11-12", "12-13", "13-14", "14-15", "15-16", "16-17", "17-18", "18-19", "19-07"]
};

const reducer=(state=initialState,action)=>{
  switch(action.type){


    case actionTypes.VISITOR_COUNT_LIST:

      return {
        ...state,
        visitor_count_list: action.value
      };

    case actionTypes.VISITOR_COUNT_LIST_GRAPH:
      return {
        ...state,
        visitor_count_list_graph: action.value
      };

    case actionTypes.VISITOR_TIMES_LIST_GRAPH:
      return {
        ...state,
        visitor_times_list_graph: action.value
      };

    default:
      return state;
  }
};

export default reducer;
